<template>
  <div class="industry-news-list-filter">
    <industry-multi-select class="event" title="事件" :selected-filters="selectedTags.event" :items="newsListFilters.event" @change="onPositiveFilterChange"></industry-multi-select>
    <industry-multi-select class="emotional" title="情感" :selected-filters="selectedTags.emotional" :items="newsListFilters.emotional" @change="onNegativeFilterChange"></industry-multi-select>
  </div>
</template>

<script>
import IndustryMultiSelect from '@/components/news-monitor/IndustryMultiSelect';

export default {
  data() {
    return {
      dialogVisible: false,
      selectedOptionTab: 'industry',
      dialogSelectedTags: {
        industry: [],
        event: [],
        emotional: []
      }
    };
  },
  props: {
    selectedTags: {
      type: Object
    },
    newsListFilters: {
      type: Object
    }
  },
  methods: {
    onSelectTagClick(type, res) {
      if (type === 'industry') {
        if (this.dialogSelectedTags.industry.indexOf(res) === -1) {
          this.dialogSelectedTags.industry.push(res);
        } else {
          this.dialogSelectedTags.industry.splice(this.dialogSelectedTags.industry.indexOf(res), 1);
        }
      } else if (type === 'event') {
        if (this.dialogSelectedTags.event.indexOf(res) === -1) {
          this.dialogSelectedTags.event.push(res);
        } else {
          this.dialogSelectedTags.event.splice(this.dialogSelectedTags.event.indexOf(res), 1);
        }
      } else if (type === 'emotional') {
        if (this.dialogSelectedTags.emotional.indexOf(res) === -1) {
          this.dialogSelectedTags.emotional.push(res);
        } else {
          this.dialogSelectedTags.emotional.splice(this.dialogSelectedTags.emotional.indexOf(res), 1);
        }
      }
    },
    onDelTag(type, res) {
      if (type === 'industry') {
        this.dialogSelectedTags.industry.splice(this.dialogSelectedTags.industry.indexOf(res), 1);
      } else if (type === 'event') {
        this.dialogSelectedTags.event.splice(this.dialogSelectedTags.event.indexOf(res), 1);
      } else if (type === 'emotional') {
        this.dialogSelectedTags.emotional.splice(this.dialogSelectedTags.emotional.indexOf(res), 1);
      }
    },
    onDelAllTag() {
      this.dialogSelectedTags = {
        industry: [],
        event: [],
        emotional: []
      };
    },
    cancelBtnClick() {
      this.dialogVisible = false;
      this.dialogSelectedTags = {
        industry: [],
        event: [],
        emotional: []
      };
    },
    confirmBtnClick() {
      this.dialogVisible = false;
      const selectedTags = JSON.parse(JSON.stringify(this.dialogSelectedTags));
      this.$emit('change', selectedTags);
    },
    onFilterDialogTab(res) {
      this.selectedOptionTab = res;
    },
    onIndustryFilterChange(res) {
      this.selectedTags.industry = res;
      this.$emit('change', this.selectedTags);
    },
    onPositiveFilterChange(res) {
      this.selectedTags.event = res;
      this.$emit('change', this.selectedTags);
    },
    onNegativeFilterChange(res) {
      this.selectedTags.emotional = res;
      this.$emit('change', this.selectedTags);
    }
  },
  components: {
    IndustryMultiSelect
  }
};
</script>

<style lang="scss" scoped>
.industry-news-list-filter {
  padding: 11px 16px;
  /deep/ {

    .industry .item {
      &.active {
        color: #464d6c !important;
      }    
      &:hover {
        color: #464d6c !important;
      }
    }

    .event .item {
      &.active {
        color: #464d6c !important;
      }    
      &:hover {
        color: #464d6c !important;
      }
    }

    .positive .item {
      &.active {
        color: #ff5b65 !important;
      }    
      &:hover {
        color: #ff5b65 !important;
      }
    }

    .negative .item {
      &.active {
        color: #54cea4 !important;
      }    
      &:hover {
        color: #54cea4 !important;
      }
    }

    .emotional .item {
      &.active {
        color: #464d6c !important;
      }    
      &:hover {
        color: #464d6c !important;
      }
    }
  }
}
  .check-more-btn {
    position: absolute;
    right: 16px;
    width: 24px;
    height: 24px;
    padding: 4px;
    background-color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    .check-more-img {
      width: 16px;
      height: 16px;
      background: url("../../assets/img/check-more-tag.svg") no-repeat;
      background-size: cover;
      transform: rotateZ(0deg);
      translate: transform .1s;
      -webkit-transition: transform .1s;
    }
    .check-more-img-reverse {
      transform: rotateZ(180deg);
      }
  }
  .industry-btn {
    top: 15px;
  }
  .positive-btn {
    top: 15px;
  }
  .negative-btn {
    top: 84px;
  }
  .neutral-btn {
    top: 118px;
  }
/deep/.filter-dialog {
  .dialog-selected {
    padding: 16px 16px 6px;
    width: 100%;
    min-height: 56px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .selected {
      width: 44px;
    }
    .selected-tag {
      flex: 1;
      flex-wrap: wrap;
      .industry-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 12px;
        border-radius: 4px;
        border: solid 1px #4f4e55;
        color: #ffffff;
        font-size: 14px;
      }
      .positive-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 12px;
        border-radius: 4px;
        border: solid 1px #4f4e55;
        color: #ff5b65;
        font-size: 14px;
      }
      .negative-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 12px;
        border-radius: 4px;
        border: solid 1px #4f4e55;
        color: #54cea4;
        font-size: 14px;
      }
      .neutral-tag {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 2px 12px;
        border-radius: 4px;
        border: solid 1px #4f4e55;
        color: #ffffff;
        font-size: 14px;
      }
      .del-img {
        margin-left: 4px;
        margin-top: 2px;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/del-img.svg") no-repeat;
        background-size: cover; 
        cursor: pointer;
      }
      .delAllBtn {
        height: 24px;
        height: 24px;
        padding: 2px 12px;
        border-radius: 4px;
        background-color: #4f4e55;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        .del-all-img {
          margin-right: 4px;
          margin-top: 2px;
          width: 16px;
          height: 16px;
          background: url("../../assets/img/del-all-img.svg") no-repeat;
          background-size: cover; 
        }
      }
    }
  }
  .dialog-tab {
    position: relative;
    width: 100%;
    height: 48px;
    padding: 14px 0 0 16px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .tab-btn {
      margin-right: 40px;
      cursor: pointer;
    }
    .active {
      position: relative;
      color: #ffffff;
      font-weight: 500;
    }
    .active::after {
      content: '';
      position: absolute;
      bottom: 1px;
      left: 5px;
      width: 18px;
      height: 2px;
      background-color: #45a8cc;
    }
  }
  .dialog-content {
    padding: 16px;
    width: 100%;
    height: 240px;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .dialog-detail {
      flex-wrap: wrap;
      .dialog-detail-item {
        padding: 2px 8px;
        margin: 0 10px 16px 0;
        border-radius: 4px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
        background-color: #3c3a42;
        cursor: pointer;
      }
      .industry-active {
        color: #ffffff;
        background-color: #423f43;
        font-weight: 500;
      }
      .positive-active {
        color: #ff5b65;
        background-color: #423f43;
        font-weight: 500;
      }
      .negative-active {
        color: #54cea4;
        background-color: #423f43;
        font-weight: 500;
      }
      .neutral-active {
        color: #ffffff;
        background-color: #423f43;
        font-weight: 500;
      }
    }
  }
  .dialog-footer {
    width: 100%;
    height: 64px;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 64px;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 130px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          background-color: #4f4e55;
          border-radius: 2px;
          border: none;
          &:hover {
            color: rgba(255, 255, 255, 0.7);
            background-color: #4f4e55;
          }
          &:focus {
            color: rgba(255, 255, 255, 0.7);
            background-color: #4f4e55;
          }
          &:active {
            color: rgba(255, 255, 255, 0.7);
            background-color: #4f4e55;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #45a8cc;
          border-radius: 2px;
          border: none;
          font-weight: 500;
          &:hover {
            color: #ffffff;
            background-color: #45a8cc;
          }
          &:focus {
            color: #ffffff;
            background-color: #45a8cc;
          }
          &:active {
            color: #ffffff;
            background-color: #45a8cc;
          }
        }
      }
    }
  }
  .el-dialog {
    border-radius: 2px;
    background-color: #3c3a42;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 352px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
</style>
